/**
 * Jonas' GitHub projects that have a live page.
 * ---------------------------------------------
 * Generated from the GitHub API, filtered to repositories whose `homepage` is
 * a GitHub Pages URL — those are known to frame cleanly, which matters because
 * Start > Surprise Me (GitHub) opens them *inside* Internet Explorer rather
 * than throwing the visitor out to a new tab. A project that refused to embed
 * would break the desktop rather than show off the work.
 *
 * The portfolio itself is deliberately excluded: sending someone from this
 * site to this site is not a surprise.
 *
 * To refresh: re-run the GitHub API query and regenerate. Nothing here is
 * hand-edited except the exclusions above, so it can be replaced wholesale.
 */

export interface GithubProject {
    name: string;
    url: string;
    language: string;
    description: string;
    stars: number;
}

export const GITHUB_PROJECTS: GithubProject[] = [
    {
        name: 'AirTyping',
        url: 'https://qc20.github.io/AirTyping',
        language: 'JavaScript',
        description: '',
        stars: 0,
    },
    {
        name: 'Alive',
        url: 'https://qc20.github.io/Alive',
        language: 'HTML',
        description: '',
        stars: 0,
    },
    {
        name: 'AsciiVision',
        url: 'https://qc20.github.io/AsciiVision',
        language: 'JavaScript',
        description: 'AsciiVision is a creative coding project that merges human-computer interaction with artistic…',
        stars: 2,
    },
    {
        name: 'AssemblyRings',
        url: 'https://qc20.github.io/AssemblyRings',
        language: 'CSS',
        description: 'Welcome to the Assembly Rings repository! This project is a captivating blend of interaction…',
        stars: 0,
    },
    {
        name: 'assessment-form-website',
        url: 'https://qc20.github.io/assessment-form-website',
        language: 'JavaScript',
        description: 'A browser-based survey instrument for studying managerial AI adoption, tech anxiety, and role…',
        stars: 0,
    },
    {
        name: 'Attractor',
        url: 'https://qc20.github.io/Attractor',
        language: 'JavaScript',
        description: 'This repository contains a real-time, WebGL-powered visualization of the Thomas attractor, an…',
        stars: 1,
    },
    {
        name: 'BlackHoles',
        url: 'https://qc20.github.io/BlackHoles',
        language: 'JavaScript',
        description: '',
        stars: 0,
    },
    {
        name: 'BunchOfWords',
        url: 'https://qc20.github.io/BunchOfWords',
        language: 'JavaScript',
        description: '',
        stars: 0,
    },
    {
        name: 'BW-Blobs',
        url: 'https://qc20.github.io/BW-Blobs',
        language: 'HTML',
        description: 'This repository showcases a WebGL implementation of a mesmerizing circle visualization using…',
        stars: 1,
    },
    {
        name: 'Cellular-Asciimata',
        url: 'https://qc20.github.io/Cellular-Asciimata',
        language: 'JavaScript',
        description: 'Interactive cellular automaton renderer using GPU-accelerated WebGL shaders and p5.asciify fo…',
        stars: 0,
    },
    {
        name: 'Circle-In-Circle',
        url: 'https://qc20.github.io/Circle-In-Circle',
        language: 'HTML',
        description: '',
        stars: 0,
    },
    {
        name: 'CircleCircleInteraction',
        url: 'https://qc20.github.io/CircleCircleInteraction',
        language: 'JavaScript',
        description: 'This project showcases an interactive animation of moving circles using HTML5 Canvas and Java…',
        stars: 0,
    },
    {
        name: 'Circular-Mesh',
        url: 'https://qc20.github.io/Circular-Mesh',
        language: 'JavaScript',
        description: 'Circular Mesh Harmony is an interactive, generative art piece that explores the beauty of geo…',
        stars: 0,
    },
    {
        name: 'Cloth',
        url: 'https://qc20.github.io/Cloth',
        language: 'JavaScript',
        description: 'The simulation creates a grid of particles connected by constraints, mimicking the behavior o…',
        stars: 0,
    },
    {
        name: 'Colourful-Attraction',
        url: 'https://qc20.github.io/Colourful-Attraction',
        language: 'JavaScript',
        description: '100,000 GPU particles flowing through 12 strange attractors in real time. WebGL fragment shad…',
        stars: 0,
    },
    {
        name: 'Crashing-Squares-Website',
        url: 'https://qc20.github.io/Crashing-Squares-Website',
        language: 'CSS',
        description: '',
        stars: 0,
    },
    {
        name: 'credit-link',
        url: 'https://qc20.github.io/credit-link',
        language: 'JavaScript',
        description: 'This project creates an interactive particle animation. When users hover over or touch the te…',
        stars: 0,
    },
    {
        name: 'CurlNoise',
        url: 'https://qc20.github.io/CurlNoise',
        language: 'JavaScript',
        description: '',
        stars: 1,
    },
    {
        name: 'Dadras-Attractor',
        url: 'https://qc20.github.io/Dadras-Attractor',
        language: 'JavaScript',
        description: 'Interactive browser-based explorer of chaotic dynamical systems. Visualize eleven strange att…',
        stars: 0,
    },
    {
        name: 'Deformation',
        url: 'https://qc20.github.io/Deformation',
        language: 'JavaScript',
        description: 'Deformation creates an immersive, full-screen particle animation driven by elegant, reactive…',
        stars: 0,
    },
    {
        name: 'DeJong-Attractor',
        url: 'https://qc20.github.io/DeJong-Attractor',
        language: 'HTML',
        description: 'This project provides a WebGL-based visualization of the de Jong attractor, a type of strange…',
        stars: 1,
    },
    {
        name: 'DigitalOrganism',
        url: 'https://qc20.github.io/DigitalOrganism',
        language: 'JavaScript',
        description: 'DigitalOrganism is an interactive, visually captivating cellular automaton simulation that ex…',
        stars: 3,
    },
    {
        name: 'Discrete-Mandelbrot',
        url: 'https://qc20.github.io/Discrete-Mandelbrot',
        language: 'JavaScript',
        description: 'Explore an interactive Mandelbrot set with a discrete, blocky visual language. GPU-accelerate…',
        stars: 0,
    },
    {
        name: 'Dotted-Geometries',
        url: 'https://qc20.github.io/Dotted-Geometries',
        language: 'JavaScript',
        description: 'A generative visualization exploring perception through resolution. Transform 3D geometry int…',
        stars: 0,
    },
    {
        name: 'ElectromagneticField',
        url: 'https://qc20.github.io/ElectromagneticField',
        language: 'JavaScript',
        description: 'ElectromagneticField: An interactive HTML5 Canvas visualization simulating electromagnetic in…',
        stars: 4,
    },
    {
        name: 'Elemental-Interfaces',
        url: 'https://qc20.github.io/Elemental-Interfaces',
        language: 'JavaScript',
        description: 'An interactive 3D periodic table visualization that morphs between table, sphere, helix, and…',
        stars: 0,
    },
    {
        name: 'Emergent-Loops',
        url: 'https://qc20.github.io/Emergent-Loops',
        language: 'HTML',
        description: 'A generative art piece exploring emergent patterns through layered noise functions. Combines…',
        stars: 1,
    },
    {
        name: 'EmojiAdventure',
        url: 'https://qc20.github.io/EmojiAdventure',
        language: 'JavaScript',
        description: 'EmojiAdventure: An interactive digital art experience that generates a dynamic, ever-changing…',
        stars: 2,
    },
    {
        name: 'EmojiHeatmap',
        url: 'https://qc20.github.io/EmojiHeatmap',
        language: 'JavaScript',
        description: 'EmojiHeatmap is a creative visualization tool that dynamically generates a heatmap using a va…',
        stars: 3,
    },
    {
        name: 'Flow-Mirror',
        url: 'https://qc20.github.io/Flow-Mirror',
        language: 'JavaScript',
        description: 'An interactive webcam visualization that transforms your camera feed into flowing, organic pa…',
        stars: 3,
    },
    {
        name: 'fractured-entropy',
        url: 'https://qc20.github.io/fractured-entropy',
        language: 'JavaScript',
        description: 'Interactive mathematical art exploring chaotic attractors through real-time visualization. A…',
        stars: 4,
    },
    {
        name: 'game-of-life-simulation',
        url: 'https://qc20.github.io/game-of-life-simulation',
        language: 'JavaScript',
        description: 'Fun and interactive interpretation of the Game of Life project written in p5.js. Is controlla…',
        stars: 3,
    },
    {
        name: 'gameoflife',
        url: 'https://qc20.github.io/gameoflife',
        language: 'JavaScript',
        description: 'This project implements Conway’s Game of Life, a cellular automaton simulation, using JavaScr…',
        stars: 2,
    },
    {
        name: 'GLSL-NoiseSoup',
        url: 'https://qc20.github.io/GLSL-NoiseSoup',
        language: 'HTML',
        description: 'Noise Soup: An interactive WebGL experiment merging design and code. Create stunning visual e…',
        stars: 4,
    },
    {
        name: 'GLSL-Shader',
        url: 'https://qc20.github.io/GLSL-Shader',
        language: 'JavaScript',
        description: 'This repository contains a WebGL project that demonstrates shader animation using WebGL (Web…',
        stars: 1,
    },
    {
        name: 'Gravitational-Attractors',
        url: 'https://qc20.github.io/Gravitational-Attractors',
        language: 'JavaScript',
        description: '',
        stars: 0,
    },
    {
        name: 'hallucinatory-phantasmagoria',
        url: 'https://qc20.github.io/hallucinatory-phantasmagoria',
        language: 'JavaScript',
        description: 'Real-time generative shader experience rendering infinite abstract landscapes through WebGL2.…',
        stars: 0,
    },
    {
        name: 'Hexa-Vision',
        url: 'https://qc20.github.io/Hexa-Vision',
        language: 'JavaScript',
        description: 'Real-time WebGL visual experiment combining animated Voronoi surface displacement on a proced…',
        stars: 1,
    },
    {
        name: 'InkDrop',
        url: 'https://qc20.github.io/InkDrop',
        language: 'HTML',
        description: '',
        stars: 0,
    },
    {
        name: 'Latex-Wave',
        url: 'https://qc20.github.io/Latex-Wave',
        language: 'JavaScript',
        description: 'This repository hosts an interactive WebGL-based dynamic art generator implemented using HTML…',
        stars: 1,
    },
    {
        name: 'Moving-Earth',
        url: 'https://qc20.github.io/Moving-Earth',
        language: 'JavaScript',
        description: '',
        stars: 0,
    },
    {
        name: 'News-Site',
        url: 'https://qc20.github.io/News-Site',
        language: 'HTML',
        description: '',
        stars: 0,
    },
    {
        name: 'Noct',
        url: 'https://qc20.github.io/Noct',
        language: 'JavaScript',
        description: '',
        stars: 0,
    },
    {
        name: 'non-cartesian-etch-a-sketch',
        url: 'https://qc20.github.io/non-cartesian-etch-a-sketch',
        language: 'JavaScript',
        description: 'The Non-Cartesian Etch-A-Sketch is a browser-based simulation that offers a unique drawing ex…',
        stars: 0,
    },
    {
        name: 'OrderedChaos',
        url: 'https://qc20.github.io/OrderedChaos',
        language: 'JavaScript',
        description: 'Welcome to **Particle Playground** - an interactive, mesmerizing simulation where 45,000 part…',
        stars: 0,
    },
    {
        name: 'particle-walker',
        url: 'https://qc20.github.io/particle-walker',
        language: 'JavaScript',
        description: 'This project is an interactive particle swarm visualization that responds to user input, crea…',
        stars: 4,
    },
    {
        name: 'ParticleSky',
        url: 'https://qc20.github.io/ParticleSky',
        language: 'JavaScript',
        description: '',
        stars: 1,
    },
    {
        name: 'PinPortrait',
        url: 'https://qc20.github.io/PinPortrait',
        language: 'JavaScript',
        description: 'PinPortrait: An immersive 3D webcam pixelation experiment. Transform your live video feed int…',
        stars: 7,
    },
    {
        name: 'Playful-Determinism',
        url: 'https://qc20.github.io/Playful-Determinism',
        language: 'JavaScript',
        description: 'A generative canvas animation that creates an infinite swirling pattern through radial wave p…',
        stars: 1,
    },
    {
        name: 'PolygonPlayground',
        url: 'https://qc20.github.io/PolygonPlayground',
        language: 'JavaScript',
        description: 'An interactive 3D physics playground where polygons come to life, blending design and technol…',
        stars: 5,
    },
    {
        name: 'Pulsar-Waveform',
        url: 'https://qc20.github.io/Pulsar-Waveform',
        language: 'JavaScript',
        description: 'Designed by Peter Saville, the cover’s minimalist and enigmatic aesthetic has resonated deepl…',
        stars: 0,
    },
    {
        name: 'Randomized-Perlin-Noise',
        url: 'https://qc20.github.io/Randomized-Perlin-Noise',
        language: 'HTML',
        description: 'A generative art experiment creating dynamic, organic visual landscapes through algorithmic m…',
        stars: 0,
    },
    {
        name: 'Scroll.',
        url: 'https://qc20.github.io/Scroll.',
        language: 'JavaScript',
        description: 'Scroll Gallery is a web application designed to showcase digital artworks in an interactive,…',
        stars: 1,
    },
    {
        name: 'Shaders-Triangles',
        url: 'https://qc20.github.io/Shaders-Triangles',
        language: 'CSS',
        description: 'This project showcases an interactive, color-shifting 3D cube using pure CSS. It demonstrates…',
        stars: 0,
    },
    {
        name: 'Signature',
        url: 'https://qc20.github.io/Signature',
        language: 'JavaScript',
        description: 'This project creates an interactive canvas element that generates a trailing effect following…',
        stars: 1,
    },
    {
        name: 'skinny-cv',
        url: 'https://qc20.github.io/skinny-cv',
        language: 'TypeScript',
        description: '',
        stars: 0,
    },
    {
        name: 'SlimeMolds',
        url: 'https://qc20.github.io/SlimeMolds',
        language: 'JavaScript',
        description: 'This project is an interactive visualization that explores the fascinating world of emergent…',
        stars: 5,
    },
    {
        name: 'Sloppy-Donut',
        url: 'https://qc20.github.io/Sloppy-Donut',
        language: 'JavaScript',
        description: 'Interactive generative art exploring particle dynamics through WebGL shaders and real-time ph…',
        stars: 1,
    },
    {
        name: 'Smoke',
        url: 'https://qc20.github.io/Smoke',
        language: 'HTML',
        description: '',
        stars: 0,
    },
    {
        name: 'Soup',
        url: 'https://qc20.github.io/Soup',
        language: 'HTML',
        description: 'This project is an exploration of procedural textures, interactive animations, and the mesmer…',
        stars: 0,
    },
    {
        name: 'Speculative-Geometry',
        url: 'https://qc20.github.io/Speculative-Geometry',
        language: 'JavaScript',
        description: '',
        stars: 0,
    },
    {
        name: 'Sticks-and-Noodles',
        url: 'https://qc20.github.io/Sticks-and-Noodles',
        language: 'CSS',
        description: 'An interactive Matter.js-based mock-up website for a noodle joint.',
        stars: 0,
    },
    {
        name: 'Strange-Networks',
        url: 'https://qc20.github.io/Strange-Networks',
        language: 'JavaScript',
        description: 'A generative network visualization built with p5.js. Five interactive layout modes, Catmull-R…',
        stars: 0,
    },
    {
        name: 'StripedBlob',
        url: 'https://qc20.github.io/StripedBlob',
        language: 'HTML',
        description: 'This project showcases an interactive 3D wave visualization using Three.js and custom WebGL s…',
        stars: 0,
    },
    {
        name: 'Teach-XAI-with-P5.js',
        url: 'https://qc20.github.io/Teach-XAI-with-P5.js',
        language: 'JavaScript',
        description: 'Discover Explainable AI (XAI) through interactive visualizations with P5.js. Dive into the wo…',
        stars: 0,
    },
    {
        name: 'Text-Morph',
        url: 'https://qc20.github.io/Text-Morph',
        language: 'JavaScript',
        description: '',
        stars: 0,
    },
    {
        name: 'Truchet-Tiles',
        url: 'https://qc20.github.io/Truchet-Tiles',
        language: 'JavaScript',
        description: 'An interactive web-based implementation of Truchet tiling - a mathematical pattern system tha…',
        stars: 0,
    },
    {
        name: 'warped-room',
        url: 'https://qc20.github.io/warped-room',
        language: 'JavaScript',
        description: '',
        stars: 0,
    },
    {
        name: 'WaterColor',
        url: 'https://qc20.github.io/WaterColor',
        language: 'JavaScript',
        description: 'An interactive web-based oil painting simulation that allows users to create digital artworks…',
        stars: 0,
    },
    {
        name: 'wave.wav',
        url: 'https://qc20.github.io/wave.wav',
        language: 'JavaScript',
        description: 'Real-time 3D audio visualization mapping microphone input through FFT frequency analysis into…',
        stars: 0,
    },
    {
        name: 'Wavebreaker',
        url: 'https://qc20.github.io/Wavebreaker',
        language: 'JavaScript',
        description: 'This interactive sketch is designed for digital designers and user experience (UX) profession…',
        stars: 1,
    },
    {
        name: 'WavyHairball',
        url: 'https://qc20.github.io/WavyHairball',
        language: 'HTML',
        description: 'This project showcases an interactive, fluid line animation using Three.js. It’s designed to…',
        stars: 0,
    },
];

/** One at random, never twice running. */
let last = '';
export function randomProject(): GithubProject {
    const pool = GITHUB_PROJECTS.filter((p) => p.name !== last);
    const pick = pool[Math.floor(Math.random() * pool.length)];
    last = pick.name;
    return pick;
}
